import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import backLogo from "../../../../assets/business/images/Button-icon.svg";
import thankYouImage from "../../../../assets/business/images/thank-you-img.png";

function BusinessThanksPage() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/business/login");
  };

  return (
    <div className="container section-section">
      <div className="text-start mt-3">
        <figure>
          <Link to={"/business/login"}>
            <img src={backLogo} alt="button" />
          </Link>
        </figure>
      </div>
      <div className="thank-you-wrapper text-center">
        <div className="logo">
          <img src={thankYouImage} alt="Logo" />
        </div>
        <h4 className="h2-headline">Thank you!</h4>
        <p className="subtitle-1 text">Thank you for signing up! Your business is under review. You’ll receive an update via email/SMS within 24–48 hours.</p>
        <div className="col-md-12 text-center mt-5">
          <button
            type="submit"
            className="btn btn-light-purple  px-5"
            onClick={() => {
              handleNavigate();
            }}>
            <span className="px-3">Login</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default BusinessThanksPage;
